<script>
import Banner from "../components/PageBanner";
import Title from "../components/PageTitle";
import Tab from "../components/PageTab";
import TabMenu from "../components/PageTabMenu";
import Footer from "../components/Footer";

export default {
  name: "PageDataLab",
  components: {
    Banner,
    Title,
    Tab,
    TabMenu,
    Footer,
  },
  mounted() {},
};
</script>

<template>
  <div class="page-main">
    <Banner bannerImage="bannerParams" hasAvatar="0" />
    <Title title="Laboratoire des données" />

    <TabMenu item1="100">
      <template v-slot:body>
        <Tab text="Fusionner" :route="{ name: 'Fusion' }" customWidth="150" />
      </template>
    </TabMenu>

    <div class="page-main-container">
      <router-view></router-view>
    </div>

    <Footer />
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/main.scss";

@include page-main;
</style>
